import CurrencyUtils from "@/lib/currencyUtils";
import DepositOverdraftInterestSettings from "@/models/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettings";

export default class UpdateDepositOverdraftInterestSettingsRequest extends DepositOverdraftInterestSettings {
    updatedAt: Date;

    public constructor(settings: DepositOverdraftInterestSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.interestBearingThreshold = settings.interestBearingThreshold;
            this.interestBearingThreshold.currency = defaultWalletCurrency;
            this.interestBearingThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(this.interestBearingThreshold.amount);
            this.accruedPeriodOnDayOfMonth = settings.accruedPeriodOnDayOfMonth;
            this.accruedPeriodOnDayOfWeek = settings.accruedPeriodOnDayOfWeek;
            this.accruedPeriodOnMonth = settings.accruedPeriodOnMonth;
            this.accruedPeriodType = settings.accruedPeriodType;
            this.accruedPeriodValue = settings.accruedPeriodValue;
            this.accruedPeriodValue = +this.accruedPeriodValue;
            this.calculatedOnBalanceType = settings.calculatedOnBalanceType;
            this.daysInYearType = settings.daysInYearType;
            this.nonWorkingDaysType = settings.nonWorkingDaysType;
            this.postedPeriodOnDayOfMonth = settings.postedPeriodOnDayOfMonth;
            this.postedPeriodOnDayOfWeek = settings.postedPeriodOnDayOfWeek;
            this.postedPeriodOnMonth = settings.accruedPeriodOnMonth;
            this.postedPeriodType = settings.postedPeriodType;
            this.postedPeriodValue = settings.postedPeriodValue;
            this.postedPeriodValue = +this.postedPeriodValue;
            this.rateType = settings.rateType;
            this.rateValue = +settings.rateValue;
            this.rateSourceId = settings.rateSourceId;
        }
    }
}